import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=63fa0e55"
import script from "./TransactionView.vue?vue&type=script&lang=js"
export * from "./TransactionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports